"use client";
import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import NavbarMobileBanners from "./NavbarMobileBanners";
import { usePathname } from "next/navigation";
import { useMediaQuery, useTheme } from "@mui/system";
import GetAppNotification from "../get-app/GetAppNotification";
import { isHomeHubPath } from "./homeHubPath";

export const NavbarWraper = () => {
  const [reloadScrollFlag, setReloadScrollFlag] = useState(false);
  const [reloadNavBackground, setReloadNavBackground] = useState();
  const [visible, setVisible] = useState(true);
  const [reloadSearchPositionFlag, setReloadSearchPositionFlag] =
    useState(false);
  const pathname = usePathname();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!isHomeHubPath(pathname)) {
      setReloadScrollFlag(true);
      setReloadSearchPositionFlag(true);
    }
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isHomeHubPath(pathname) && isSmallScreen && (
        <GetAppNotification visible={visible} setVisible={setVisible} />
      )}
      <Navbar
        setReloadCartService={() => {}}
        reloadScrollFlag={reloadScrollFlag}
        reloadSearchPositionFlag={reloadSearchPositionFlag}
        reloadNavBackground={reloadNavBackground}
        visible={visible}
      />
      {isHomeHubPath(pathname) && isSmallScreen && (
        <NavbarMobileBanners
          setReloadScrollFlag={setReloadScrollFlag}
          setReloadSearchPositionFlag={setReloadSearchPositionFlag}
          reloadNavBackground={setReloadNavBackground}
        />
      )}
    </>
  );
};
